import { HttpClient } from '@wix/sdk-types';
import {
  GetGiftCardOptions,
  GetGiftCardResponse,
  GetGiftCardResponseNonNullableFields,
  RedeemGiftCardOptions,
  RedeemGiftCardResponse,
  RedeemGiftCardResponseNonNullableFields,
  VoidTransactionOptions,
  getGiftCard as universalGetGiftCard,
  redeemGiftCard as universalRedeemGiftCard,
  voidTransaction as universalVoidTransaction,
} from './ecom-v1-gift-card-gift-vouchers.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function getGiftCard(httpClient: HttpClient): GetGiftCardSignature {
  return (code: string, options?: GetGiftCardOptions) =>
    universalGetGiftCard(
      code,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetGiftCardSignature {
  /**
   * Retrieves a gift card.
   * @param - Gift card code.
   * @param - Field options.
   */
  (code: string, options?: GetGiftCardOptions | undefined): Promise<
    GetGiftCardResponse & GetGiftCardResponseNonNullableFields
  >;
}

export function redeemGiftCard(
  httpClient: HttpClient
): RedeemGiftCardSignature {
  return (code: string, options?: RedeemGiftCardOptions) =>
    universalRedeemGiftCard(
      code,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface RedeemGiftCardSignature {
  /**
   * Redeems a gift card.
   * Creates a transaction and lowers the card balance by the transaction amount.
   * @param - Gift card code.
   * @param - Field options. `amount` and `appId` **must** be passed.
   */
  (code: string, options?: RedeemGiftCardOptions | undefined): Promise<
    RedeemGiftCardResponse & RedeemGiftCardResponseNonNullableFields
  >;
}

export function voidTransaction(
  httpClient: HttpClient
): VoidTransactionSignature {
  return (transactionId: string, options?: VoidTransactionOptions) =>
    universalVoidTransaction(
      transactionId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface VoidTransactionSignature {
  /**
   * Voids a gift card transaction.
   * Transaction IDs are returned in Redeem Gift Card.
   * @param - Gift card transaction ID, as returned from Redeem Gift Card.
   * @param - Field options. `appId` **must** be passed.
   */
  (
    transactionId: string,
    options?: VoidTransactionOptions | undefined
  ): Promise<void>;
}

export {
  Context,
  GetGiftCardOptions,
  GetGiftCardRequest,
  GetGiftCardResponse,
  GetGiftCardResponseNonNullableFields,
  GiftCard,
  Money,
  RedeemGiftCardOptions,
  RedeemGiftCardRequest,
  RedeemGiftCardResponse,
  RedeemGiftCardResponseNonNullableFields,
  Status,
  VoidTransactionOptions,
  VoidTransactionRequest,
  VoidTransactionResponse,
} from './ecom-v1-gift-card-gift-vouchers.universal.js';
